// TODO[Dmitriy Teplov] extract from studio utils.
export function formatSpentMoney(amount: number): string {
  return `$${(amount / 100).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
}

export function formatPercentage(percentage: number): string {
  return `${(percentage * 100).toFixed(0)}%`;
}
